import { jobLists } from "character";
import { EorzeaDataType, GameData, RelicData } from "enums";
import { Info } from "types/game";

export const sbItems = {
	[GameData.Item.PROTEAN_CRYSTAL]: {
		name: GameData.Item.PROTEAN_CRYSTAL,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			other: [
				{ element: "p", text: "Drops from any mob in Eureka" },
				{ element: "p", text: "Trade in Anemos Crystals which are obtained from FATEs in Eureka" },
			],
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_EUREKA, RelicData.Part.WEAPON_ANEMOS, RelicData.Step.ANEMOS_0, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.WEAPON_EUREKA],
				qtyPerJob: 100,
			},
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_EUREKA, RelicData.Part.WEAPON_ANEMOS, RelicData.Step.ANEMOS_1, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.WEAPON_EUREKA],
				qtyPerJob: 400,
			},
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_EUREKA, RelicData.Part.WEAPON_ANEMOS, RelicData.Step.ANEMOS_2, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.WEAPON_EUREKA],
				qtyPerJob: 800,
			},
		],
	},
	[GameData.Item.PAZUZUS_FEATHER]: {
		name: GameData.Item.PAZUZUS_FEATHER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.EXPEDITION_BIRDWATCHER_ANEMOS, cost: [{ price: 300, currency: GameData.Item.PROTEAN_CRYSTAL }] },
				{ shop: GameData.Shop.EXPEDITION_BIRDWATCHER_PYROS, cost: [{ price: 300, currency: GameData.Item.PROTEAN_CRYSTAL }] },
				{ shop: GameData.Shop.EXPEDITION_BIRDWATCHER_PAGOS, cost: [{ price: 300, currency: GameData.Item.PROTEAN_CRYSTAL }] },
			],
			duties: { fates: [GameData.Fate.WAIL_IN_THE_WILLOWS] },
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_EUREKA, RelicData.Part.WEAPON_ANEMOS, RelicData.Step.ANEMOS, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.WEAPON_EUREKA],
				qtyPerJob: 3,
			},
		],
	},
	[GameData.Item.FROSTED_PROTEAN_CRYSTAL]: {
		name: GameData.Item.FROSTED_PROTEAN_CRYSTAL,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { other: [{ element: "p", text: "Fill Kettle with Vitiated Aether and each full bar can be converted at the Crystal Forge into Frosted Protean Crystals" }] },
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_EUREKA, RelicData.Part.WEAPON_ELEMENTAL, RelicData.Step.PAGOS, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.WEAPON_EUREKA],
				qtyPerJob: 5,
			},
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_EUREKA, RelicData.Part.WEAPON_ELEMENTAL, RelicData.Step.PAGOS_1, RelicData.Task.TASK_2],
				jobs: jobLists.relic[RelicData.Group.WEAPON_EUREKA],
				qtyPerJob: 10,
			},
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_EUREKA, RelicData.Part.WEAPON_ELEMENTAL, RelicData.Step.ELEMENTAL, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.WEAPON_EUREKA],
				qtyPerJob: 16,
			},
		],
	},
	[GameData.Item.PAGOS_CRYSTAL]: {
		name: GameData.Item.PAGOS_CRYSTAL,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { other: [{ element: "p", text: "FATEs in Eureka Pagos" }] },
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_EUREKA, RelicData.Part.WEAPON_ELEMENTAL, RelicData.Step.PAGOS_1, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.WEAPON_EUREKA],
				qtyPerJob: 500,
			},
		],
	},
	[GameData.Item.LOUHIS_ICE]: {
		name: GameData.Item.LOUHIS_ICE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.EXPEDITION_BIRDWATCHER_ANEMOS, cost: [{ price: 50, currency: GameData.Item.PAGOS_CRYSTAL }] },
				{ shop: GameData.Shop.EXPEDITION_BIRDWATCHER_PYROS, cost: [{ price: 50, currency: GameData.Item.PAGOS_CRYSTAL }] },
				{ shop: GameData.Shop.EXPEDITION_BIRDWATCHER_PAGOS, cost: [{ price: 50, currency: GameData.Item.PAGOS_CRYSTAL }] },
			],
			duties: { fates: [GameData.Fate.LOUHI_ON_ICE] },
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_EUREKA, RelicData.Part.WEAPON_ELEMENTAL, RelicData.Step.ELEMENTAL, RelicData.Task.TASK_2],
				jobs: jobLists.relic[RelicData.Group.WEAPON_EUREKA],
				qtyPerJob: 5,
			},
		],
	},
	[GameData.Item.PYROS_CRYSTAL]: {
		name: GameData.Item.PYROS_CRYSTAL,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { other: [{ element: "p", text: "FATEs in Eureka Pyros" }] },
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_EUREKA, RelicData.Part.WEAPON_PYROS, RelicData.Step.ELEMENTAL_1, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.WEAPON_EUREKA],
				qtyPerJob: 150,
			},
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_EUREKA, RelicData.Part.WEAPON_PYROS, RelicData.Step.ELEMENTAL_2, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.WEAPON_EUREKA],
				qtyPerJob: 200,
			},
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_EUREKA, RelicData.Part.WEAPON_PYROS, RelicData.Step.PYROS, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.WEAPON_EUREKA],
				qtyPerJob: 300,
			},
		],
	},
	[GameData.Item.PENTHESILEAS_FLAME]: {
		name: GameData.Item.PENTHESILEAS_FLAME,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.EXPEDITION_BIRDWATCHER_ANEMOS, cost: [{ price: 50, currency: GameData.Item.PYROS_CRYSTAL }] },
				{ shop: GameData.Shop.EXPEDITION_BIRDWATCHER_PYROS, cost: [{ price: 50, currency: GameData.Item.PYROS_CRYSTAL }] },
				{ shop: GameData.Shop.EXPEDITION_BIRDWATCHER_PAGOS, cost: [{ price: 50, currency: GameData.Item.PYROS_CRYSTAL }] },
			],
			duties: { fates: [GameData.Fate.LOST_EPIC] },
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_EUREKA, RelicData.Part.WEAPON_PYROS, RelicData.Step.PYROS, RelicData.Task.TASK_2],
				jobs: jobLists.relic[RelicData.Group.WEAPON_EUREKA],
				qtyPerJob: 5,
			},
		],
	},
	[GameData.Item.HYDATOS_CRYSTAL]: {
		name: GameData.Item.HYDATOS_CRYSTAL,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { other: [{ element: "p", text: "FATEs in Eureka Hydatos" }] },
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_EUREKA, RelicData.Part.WEAPON_EUREKA, RelicData.Step.HYDATOS, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.WEAPON_EUREKA],
				qtyPerJob: 50,
			},
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_EUREKA, RelicData.Part.WEAPON_EUREKA, RelicData.Step.HYDATOS_1, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.WEAPON_EUREKA],
				qtyPerJob: 100,
			},
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_EUREKA, RelicData.Part.WEAPON_EUREKA, RelicData.Step.BASE, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.WEAPON_EUREKA],
				qtyPerJob: 100,
			},
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_EUREKA, RelicData.Part.WEAPON_EUREKA, RelicData.Step.EUREKA, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.WEAPON_EUREKA],
				qtyPerJob: 100,
			},
		],
	},
	[GameData.Item.CRYSTALLINE_SCALE]: {
		name: GameData.Item.CRYSTALLINE_SCALE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { duties: { fates: [GameData.Fate.CRYSTALLINE_PROVENANCE] } },
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_EUREKA, RelicData.Part.WEAPON_EUREKA, RelicData.Step.EUREKA, RelicData.Task.TASK_2],
				jobs: jobLists.relic[RelicData.Group.WEAPON_EUREKA],
				qtyPerJob: 5,
			},
		],
	},
	[GameData.Item.EUREKA_FRAGMENT]: {
		name: GameData.Item.EUREKA_FRAGMENT,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { other: [{ element: "p", text: "Obtained from Baldesion Arsenal" }] },
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_EUREKA, RelicData.Part.WEAPON_PHYSEOS, RelicData.Step.FRAGMENTS, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.WEAPON_EUREKA],
				qtyPerJob: 100,
			},
		],
	},
} satisfies Partial<{ [key in GameData.Item]: Info.Item }>;
